module.exports = __webpack_public_path__ + "images/feature/141110_zoom_3-808678c841f00ac2bb409c5099e27b97.png";